import { Component } from '@angular/core';


@Component({
	selector: 'devo-donors-tab-1-part',
	standalone: true,
	templateUrl: './devo-donors-tab-1.part.html',
	styleUrls: [`./devo-donors-tab-1.part.scss`],
})
export class DevoDonorsTab1Part {
}
